<style scoped>

    table {
        font-size: 14px;
    }
</style>
<template>
    <div>

        <a v-shortkey="{keys: 'f', title:'New Bag', description: 'Quick Search Patients'}" @shortkey="setSearchFocus"></a>
        <br />
        <div class="row">
            <div class="col-md-4 col-sm-6">
                <h4>Search Existing Patients</h4>
                <PatientSearchBox v-model="Patient" :focus="searchFocus"></PatientSearchBox>
            </div>
        </div>
        <br /><br />
        <div class="row" style="border-bottom:1px solid gray">
            <div class="col-md-4 col-sm-6">
                &nbsp;
            </div>
            
        </div>
        <div class="row">
            <div class="col-md-12">
                <h4>Create New Patient</h4>
                <NewPatientForm v-model="Patient"></NewPatientForm>
            </div>
        </div>
        <div class="row well" v-if="Patient!=null">
            <div class="col-md-8 col-sm-6 ">
                <h3 style="margin-top:10px;margin-bottom:2px">{{Patient.firstName}} {{Patient.lastName}}</h3>
                <table>
                    <tr><td><small><strong>Dob :</strong></small></td><td><small>{{FormatDate(Patient.dob)}}</small></td></tr>
                    <tr><td><small><strong>Nhs Id :</strong></small></td><td><small>{{Patient.nhsNumber}}</small></td></tr>
                    <tr>
                        <td><small><strong>Address :</strong></small></td>
                        <td>
                            <small>
                                <span>{{Patient.addressLine}}       </span>
                                <span>{{Patient.postCode}}    </span>
                            </small>
                        </td>
                    </tr>
                </table>

            </div>
        </div>
        <a v-shortkey="{keys:'s', title:'New Bag', description:'Submit / Create (if patient selected)'}" @shortkey="create" />
        <a v-shortkey="{keys:'c', title:'New Bag', description:'Cancel Patient Selection'}" @shortkey="create" />

        <div class="row" v-if="Patient!=null">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="col-md-12 col-lg-12 col-sm-12" style="padding:10px">
                    <!--<a v-shortkey="{keys:'n', title:'Workslate', description:'New Bag'}" @shortkey="NewBag"></a>-->
                    <a class="btn btn-primary" @click.prevent="create"><i class="fa fa-shopping-bag" />     Create Bag</a>
                    <a class="btn btn-warning"
                       v-shortkey="{keys:'c', title:'New Bag', description:'Cancel Patient Selection'}"
                       @shortkey="Patient=null" @click="Patient = null"><i class="fa fa-ban" />Cancel</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import $ from 'jquery';
    import FmdDal from "../../../scripts/FmdDal";
    import Formatter from "../../corecontrols/formatters/Formatter";
    import forminput from "../../corecontrols/forminput/forminput.scp.html";
    import PatientSearchBox from "../../appcontrols/PatientSearchBox/PatientSearchBox.scp.html"
    import NewPatientForm from "../../appcontrols/NewPatientForm/NewPatientForm.scp.html"

    export default {
        props: ['bagId'],
        components: {
            PatientSearchBox,
            forminput,
            NewPatientForm
        },
        data: function () {
            return {
                IsNew: false,
                IsNewPatient: true,
                Patient: null,
                searchFocus: false,
                FmdDal : undefined
            }
        },
        created() {
            var that = this;

        },
        mounted() {
            this.FmdDal = new FmdDal(this.$root.CurrentUnitId, this.$root.UiSession)

            if (!this.bagId) {
                this.IsNew = true;
            }
            this.$nextTick(() => this.setSearchFocus());
        },
        methods: {
            setSearchFocus() {
                this.searchFocus = false;
                var that = this;
                this.$nextTick(() => that.searchFocus = true);
            },
            create() {
                this.FmdDal.CreateBag(this.Patient.id)
                    .then(bag => {
                        console.log("New bag..... ", bag)
                        this.$router.push({ path: 'bag/' + bag.id });
                    })
                //alert('creating')
            },
            FormatTime(dt) {
                return Formatter.FormatTime(dt)
            },
            FormatDate(dt) {
                return Formatter.FormatDate(dt)
            },
            StartNewPatient() {
                this.IsEnteringNewPatient = true
            }
        }
    }
</script>


// WEBPACK FOOTER //
// NewBag.scp.html?6ac43eed